var _path, _ellipse, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _circle, _path2, _circle2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _polygon, _path0, _path1, _path10, _path11, _rect16, _rect17, _path12, _rect18, _rect19, _path13, _path14, _path15, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmountError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "_") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.22,65.59C70.31,78.06,47.39,91,42.43,129.19c-4.18,32.22,1.42,96.16,60.2,106.3,114.38,19.74,220.68,17,241.27-37.63C365,141.84,371.52,84,307.45,70.19,262.13,60.42,170.44,41.25,104.22,65.59Z",
    fill: "#e6e6e6",
    opacity: 0.3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 189.19,
    cy: 259.79,
    rx: 134.12,
    ry: 15.47,
    fill: "#e6e6e6",
    opacity: 0.45
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 133.32,
    y: 52.17,
    width: 161.36,
    height: 200.32,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 133.32,
    y: 52.17,
    width: 161.36,
    height: 57.19,
    opacity: 0.08
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 146.09,
    y: 60.85,
    width: 135.83,
    height: 39.83,
    rx: 5.49,
    fill: "#fff",
    opacity: 0.44
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 144.39,
    y: 124.17,
    width: 31.92,
    height: 23.27,
    opacity: 0.08
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 180.44,
    y: 124.17,
    width: 31.92,
    height: 23.27,
    opacity: 0.08
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 216.5,
    y: 124.17,
    width: 31.92,
    height: 23.27,
    opacity: 0.08
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 252.56,
    y: 124.17,
    width: 31.92,
    height: 23.27,
    opacity: 0.08
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 144.39,
    y: 153.13,
    width: 31.92,
    height: 23.27,
    opacity: 0.08
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 180.44,
    y: 153.13,
    width: 31.92,
    height: 23.27,
    opacity: 0.08
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 216.5,
    y: 153.13,
    width: 31.92,
    height: 23.27,
    opacity: 0.08
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 252.56,
    y: 153.13,
    width: 31.92,
    height: 23.27,
    opacity: 0.08
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 144.39,
    y: 182.09,
    width: 31.92,
    height: 23.27,
    opacity: 0.08
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 180.44,
    y: 182.09,
    width: 31.92,
    height: 23.27,
    opacity: 0.08
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 216.5,
    y: 182.09,
    width: 31.92,
    height: 23.27,
    opacity: 0.08
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 144.39,
    y: 211.06,
    width: 67.97,
    height: 23.27,
    opacity: 0.08
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 216.5,
    y: 211.06,
    width: 31.92,
    height: 23.27,
    opacity: 0.08
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 252.56,
    y: 182.09,
    width: 31.92,
    height: 52.23,
    fill: "#ffd200"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 193.64,
    cy: 134.04,
    r: 9.68,
    fill: "#ffd200",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M195.33,147.54l-22.24,33-18.48-4.06-17.23-26.4v41.75c9.13,7.68,22.25,16.71,31.09,14.08C183.26,201.51,205,180.33,195.33,147.54Z",
    opacity: 0.08
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.64,
    cy: 134.04,
    r: 4.85,
    fill: "#ffd200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.49,138.69s-22.35,16.77-10.44,52.8S112.41,210,112.41,210V180.52Z",
    fill: "#68e1fd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.49,138.69s-22.35,16.77-10.44,52.8S112.41,210,112.41,210V180.52Z",
    fill: "#fff",
    opacity: 0.46
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M142.11,263.26l4.49,3.51a1.06,1.06,0,0,1-.65,1.9h-5.69a3,3,0,0,1-3-3v-2.37Z",
    fill: "#68e1fd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.16,263.26l-4.49,3.51a1.06,1.06,0,0,0,.65,1.9H96a3,3,0,0,0,3-3v-2.37Z",
    fill: "#68e1fd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.41,134l.77-12.72s.91-8.19,5-6.7,8.37,9.54,6.16,12c-1.19,1.35-2.45.53-4,.68-1.38.13-1.14-.08-1.14,1.31v4.86Z",
    fill: "#f4a28c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.33,133.42s-25.54-2.28-28.88,15,20.43,49.79,20.43,49.79L133,196.88S184.46,124.61,108.33,133.42Z",
    fill: "#68e1fd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M130.86,140.38s-19.81,12-10.09,30.16c6.25,11.68-9.72,27.2-9.72,27.2l22-.86s8-11.92,9.65-16.56S130.86,140.38,130.86,140.38Z",
    opacity: 0.08
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "99.88 198.17 92.36 263.26 99.72 263.27 116.16 211.02 134.68 263.28 143.1 263.28 133 196.88 99.88 198.17",
    fill: "#24285b"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M112.41,128.76h4s.87-7.36,3.69-8.77,5.63-4.07,3.13-6.5-6.07-5.25-10.24-2.35S107.33,121,112.41,128.76Z",
    fill: "#24285b"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M128.89,144.49A10,10,0,0,1,145.2,139c3.16,2.71,6.29,6.87,8.47,13.29a67.53,67.53,0,0,0,10.83,20.29,5.87,5.87,0,0,0,9.81-1l13.19-26.07,7.83,4.32s-9.08,38.84-22.55,42.6C160.74,195.78,122.48,173.17,128.89,144.49Z",
    fill: "#68e1fd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M128.89,144.49A10,10,0,0,1,145.2,139c3.16,2.71,6.29,6.87,8.47,13.29a67.53,67.53,0,0,0,10.83,20.29,5.87,5.87,0,0,0,9.81-1l13.19-26.07,7.83,4.32s-9.08,38.84-22.55,42.6C160.74,195.78,122.48,173.17,128.89,144.49Z",
    fill: "#fff",
    opacity: 0.46
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M189.19,146.44s1.44-12.75,4.57-13.77,0,7.71,0,7.71,8.62,1,1.57,9.45Z",
    fill: "#f4a28c"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 259.74,
    y: 123.11,
    width: 34.95,
    height: 44.31,
    opacity: 0.08
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 263.57,
    y: 117.93,
    width: 54.04,
    height: 44.31,
    fill: "#24285b"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M291.72,125.36c.8,0,1,.28,1,1.08v1.71a7.78,7.78,0,0,1,6.41,4.84c.41.83.24,1.29-.7,1.7l-1.71.77c-.8.38-1.18.21-1.63-.63a4.37,4.37,0,0,0-4.46-2.68c-3,0-4.31.87-4.31,2.86a2.63,2.63,0,0,0,2.4,2.33,18.48,18.48,0,0,0,2.5.38,16.55,16.55,0,0,1,4.63.91,6.33,6.33,0,0,1,2.06,1.11,6.75,6.75,0,0,1,1.84,4.87c0,3.8-2.54,6.38-7,7v1.81c0,.8-.24,1.08-1,1.08H289.8c-.8,0-1.08-.28-1.08-1.08v-1.78a7.92,7.92,0,0,1-7-5.36,1.13,1.13,0,0,1,.8-1.6l1.71-.63c.87-.31,1.25-.1,1.63.77q1.16,2.92,4.7,2.92c3.21,0,4.81-1,4.81-3.06a2.14,2.14,0,0,0-1.5-2.16,12,12,0,0,0-3.45-.66,15.23,15.23,0,0,1-4.66-1,6.46,6.46,0,0,1-2-1.15A6.36,6.36,0,0,1,281.9,135c0-3.76,2.37-6.27,6.82-6.86v-1.71c0-.8.28-1.08,1.08-1.08Z",
    fill: "#fff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 199.31,
    y: 45.19,
    width: 65.39,
    height: 6.98,
    transform: "translate(464.02 97.36) rotate(-180)",
    fill: "#e6e6e6"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 199.31,
    y: 38.17,
    width: 57.6,
    height: 6.98,
    transform: "translate(456.22 83.33) rotate(-180)",
    fill: "#ccc"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M177.89,42.37s-7.88-2.15-9.6-9.49c0,0,12.22-2.47,12.57,10.14Z",
    fill: "#68e1fd",
    opacity: 0.58
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M178.86,41.59s-5.51-8.71-.66-16.85c0,0,9.28,5.9,5.16,16.87Z",
    fill: "#68e1fd",
    opacity: 0.73
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M180.28,41.6s2.91-9.2,11.7-10.94c0,0,1.65,6-5.69,11Z",
    fill: "#68e1fd"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "174.56 41.39 176.16 52.32 186.22 52.36 187.71 41.44 174.56 41.39",
    fill: "#24285b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmountError);
export default __webpack_public_path__ + "static/media/amountError.f8093d3526693b66894ef7511a309d51.svg";
export { ForwardRef as ReactComponent };